<template>
<!-- セレクトボックス、ラジオボタン、チェックボックスの作成エリア -->
  <b-form>
    <b-row class="mt-2 mb-3">
      <b-col sm="3" class="inputLabel">
        <label>テンプレート</label>
      </b-col>
      <b-col sm="5">
        <b-form-select
          :value="template"
          @input="updateTemplate"
          :options="fieldTemplate">
          <template v-slot:first>
            <option :value="0">-- 選択してください。 --</option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col sm="3" class="inputLabel">
        <label>ラベルテキスト</label>
      </b-col>
      <b-col sm="5">
        <b-form-input
          :value="label"
          @input="updateLabel"
          placeholder="入力してください。"></b-form-input>
      </b-col>
    </b-row>

    <div
      v-for="(option, index) in options" :key="index"
      class="mt-3">
      <b-row>
        <b-col>
          <label class="flex flexCenter">選択肢{{index+1}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="3" class="inputLabel">
          <label>テキスト</label>
        </b-col>
        <b-col sm="5">
          <b-form-input
            placeholder="入力してください。"
            v-model="option.label"
          ></b-form-input>
        </b-col>
        <b-col class="flex flexLeft flexMiddle closeBtnWrap mx-0 px-0">
          <button type="button"
            class="close"
            aria-label="Close"
            @click="removeOption(index)"
            v-if="index>0"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </b-col>
        <b-col sm="3" class="flex flexCenter flexMiddle">
          <b-form-checkbox
            switches>選択時自由入力</b-form-checkbox>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col sm="3" class="inputLabel">
          <label>入力ルール</label>
        </b-col>
        <b-col sm="3">
        <b-button class="btn btn-lg float-left"
          @click="openModal(index)"
          size="sm"
          >設定する</b-button>
        </b-col>
      </b-row>
    </div>

    <b-row class="mt-2 ml-5">
      <b-col sm="3" class="inputLabel">
        <unicon name="plus-circle"
          fill="#495057"
          @click="addOption"
          class="unicon"></unicon>
      </b-col>
    </b-row>

  </b-form>
</template>

<script>
import CONST_OPTIONS from '@/constants/options';

export default {
  name: 'CmsContentsFieldsPartsChoices',
  props: ['openModal'],
  data() {
    return {
      dragOption: {
        animation: 200,
      },
    };
  },
  methods: {
    updateLabel(value) {
      this.$store.commit('cmsContentsField/updateLabel', value);
    },
    addOption() {
      this.$store.commit('cmsContentsField/addOption');
    },
    removeOption(index) {
      this.$store.commit('cmsContentsField/removeOption', index);
    },
    updateOptionText(value, index) {
      const param = { value, index };
      this.$store.commit('cmsContentsField/updateOptionText', param);
    },
    updateTemplate(value) {
      this.$store.commit('cmsContentsField/updateTemplate', value);
    },
  },
  computed: {
    label() {
      return this.$store.state.cmsContentsField.label;
    },
    template() {
      return this.$store.state.cmsContentsField.view_template;
    },
    options() {
      return this.$store.state.cmsContentsField.options;
    },
    fieldTemplate() {
      const { type } = this.$store.state.cmsContentsField;
      return CONST_OPTIONS.FIELD_TEMPLATES[type];
    },
  },
};
</script>

<style scoped>
  .closeBtnWrap {
    flex-grow: 0.2;
  }
</style>
